<template>
  <div class="container" @click="onClick()">
    <div class="burger-icon" :class="{ open }">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BurgerIcon',
  props: {
    onClick: Function,
    open: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.container {
  padding: 10px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  display: inline-block;
  margin: 0;
  margin-left: -10px;
}

.burger-icon {
  width: 20px;
  height: 20px;
  position: relative;
  top: -1px;
  margin: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -o-transition: 0.5s ease-in-out;
  transition: 0.5s ease-in-out;
  cursor: pointer;
  background: transparent;
  padding: 10px;

  span {
    display: block;
    position: absolute;
    height: 1px;
    width: 100%;
    background: #acb6c1;
    border-radius: 1px;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: 0.25s ease-in-out;
    -moz-transition: 0.25s ease-in-out;
    -o-transition: 0.25s ease-in-out;
    transition: 0.25s ease-in-out;

    &:nth-child(1) {
      top: 5px;
    }

    &:nth-child(2),
    &:nth-child(3) {
      top: 10px;
    }

    &:nth-child(4) {
      top: 15px;
    }
  }

  &.open {
    span {
      &:nth-child(1),
      &:nth-child(4) {
        top: 10px;
        width: 0%;
        left: 50%;
      }

      &:nth-child(2) {
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
      }

      &:nth-child(3) {
        -webkit-transform: rotate(-45deg);
        -moz-transform: rotate(-45deg);
        -o-transform: rotate(-45deg);
        transform: rotate(-45deg);
      }
    }
  }
}
</style>
